import React from "react";

export default function CasinoSuperskokInfo(props) {
    function renderFazi2022October() {
        return <div className="casino-superskok-section">
            <h2>PAZI, PAZI - SUPERSKOK JE UZ FAZI!</h2>

            <p>Nova SuperSkok utrka je stigla, ali ovaj put u drugačijem izdanju.</p>
            <p>Nagradni fond je 50.000 kn / 6.636,14 €, a igramo samo Fazi igre!</p>

            <p className="text"><b>Kako igrati?</b></p>
            <span className="img-character fazi"></span>
            <p>Svaki dan od 10.10. 00:00 - 16.10. do 23:59 sati igraj jednu od <b> 18 odabranih igara Fazi providera</b> uz <b>minimalni ulog 2 kn / 0,27 €</b> po vrtnji i skupljaj bodove.</p>

            <p>Bodove dobivaš na temelju <b>maksimalnog dnevnog multiplikatora</b> (multiplikator = dobitak iz vrtnje/ulog u vrtnju). Dakle, ako odigraš spin za 2 kn / 0,27 €, a dobitak je 100 kn / 13,27 € - multiplikator iznosi 50.</p>

            <p>Igrači se rangiraju prema zbroju najvećih dnevnih multiplikatora ostvarenih za vrijeme utrke. <b>TOP 150 igrača dijeli 50.000 kn / 6.636,14 €!</b></p>

            <p>A sad - tri, četiri, <b>SKOK</b> po nagrade!</p>
            <div className="divider"></div>
        </div>
    }

    function renderEGTDigital2025July() {
        return <div className="casino-superskok-section">
            <h2>SuperSkokni u EGT Digital svijet voćnih dobitaka</h2>
            <p><strong>Pripremili smo novu SuperSkok utrku s fondom od 50.000 €</strong></p>
            <p>Čeka te sočna i moćna voćna avantura. Stiže novi <strong>EGT Digital SuperSkok</strong> s nagradnim fondom od čak <strong>50.000 €</strong>! Zaigraj omiljene igre pune voćkica, sedmica, djetelina i kruna i skoči do vrha tablice!</p>
            <p><strong>Top 2000 igrača</strong> nagrađujemo prema ukupnom zbroju osvojenih multiplikatora.</p>
            <p>&nbsp;</p>
            <p><b>KAKO IGRATI?</b></p>
            <p><strong>Od 7. do 13. srpnja</strong> igraj bilo koju EGT Digital igru s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman, to bolja nagrada!</p>
            <p><strong>Top 2000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Postani dio najboljih igrača, a nagrade pogledaj ispod u tablici 👇</p>
            <p>&nbsp;</p>
            <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
            <p>&nbsp;</p>
            <div className="divider"></div>
        </div>
    }

    function renderFazi2025July() {
        return <div className="casino-superskok-section">
            <h2>SuperSkok po FAZItastični dobitak</h2>
            <p><strong>Dijelimo fantastičnih 10.000 €</strong></p>
            <p><strong>Pripremili smo s Fazijem novu SuperSkok utrku vrijednu 10.000 €</strong></p>
            <p>Lansiraj se do vrha za nagradu! Igraj najdraže Fazi igre i rangiraj se u utrci koja je neizvjesna do samoga kraja.</p>
            <p>Nagrađujemo TOP 800 igrača prema ukupnom zbroju osvojenih multiplikatora.</p>
            <p>&nbsp;</p>
            <p><b>KAKO IGRATI?</b></p>
            <p><strong>Od 21. do 27. srpnja</strong> igraj <strong>bilo koju Fazi igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman, to bolja nagrada!</p>
            <p><strong>Najboljih 800 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Postani dio najboljih igrača, a nagrade pogledaj ispod u tablici 👇</p>
            <p>&nbsp;</p>
            <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
            <p>&nbsp;</p>
            <div className="divider"></div>
        </div>
    }

    function render7777Gaming2025August() {
        return <div className="casino-superskok-section">
            <h2>Ovaj SuperSkok pršti od sretnih sedmica</h2>
            <p><strong>Uključi se u igru jer dijelimo 10.000 € vrijedan nagradni fond</strong></p>
            <p><strong>7 dana sa 7777 Gaming providerom</strong> donosi pravi žar natjecanja. Plasiraj se na rang-listu i ako završiš u <strong>TOP 800 - osvajaš nagradu!</strong></p>
            <p>Nagradni fond utrke iznosi <strong>10.000 €</strong>, ali moraš igrati <strong>minimalno 0,10 € po vrtnji</strong>.</p>
            <p>&nbsp;</p>
            <p><b>KAKO IGRATI?</b></p>
            <p><strong>Od 4. do 10. kolovoza</strong> igraj <strong>bilo koju igru 7777 Gaming providera</strong> s minimalnim ulogom od <strong>0,10 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
            <p><strong>Najboljih 800 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
            <p>&nbsp;</p>
            <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
            <p>&nbsp;</p>
            <div className="divider"></div>
        </div>
    }
    function renderFazi2025August() {
        return <div className="casino-superskok-section">
            <h2>FAZI SuperSkok: Skači prema nagradama! 🪂</h2>
            <p><strong>Uključi se u utrku i osvoji dio od 10.000 €</strong></p>
            <p>Pripremi se na pravo skakanje po ljestvici! FAZI SuperSkok donosi 8 dana uzbuđenja i priliku da osvojiš dobitak koji te može katapultirati ravno među top 800! 🎯</p>
            <p>Igraj odabrane igre FAZI providera od <strong>14. do 21. kolovoza</strong>, a sve što ti treba za ulazak u igru je <strong>minimalni ulog od 0,20 € </strong>po vrtnji.</p>
            <p>&nbsp;</p>
            <p><b>KAKO IGRATI?</b></p>
            <p>🎰 Od <strong>14. 8. do 21. 8. </strong> igraj odabrane FAZI igre</p>
            <p>💸 Minimalni ulog po vrtnji: <strong>0,20 €</strong></p>
            <p>📊 Skupljaj <strong>najveće dnevne multiplikatore*</strong></p>
            <p>🏆 <strong>Top 800 </strong>igrača osvaja dio <strong>nagradnog fonda od 10.000 €</strong></p>
            <p>&nbsp;</p>
            <p>Što veći multiplikator ostvariš, to se više penješ na rang-listi. A poredak se mijenja iz dana u dan – sve je neizvjesno do zadnjeg spina! 🎢</p>
            <p>&nbsp;</p>
            <p>Nagrade za najbolje nalaze se u tablici ispod – provjeri i vidi koliko daleko možeš skočiti! 👇</p>
            <p>&nbsp;</p>
            <p><i>*Multiplikator = dobitak / ulog. Primjer: ako uložiš 2 €, a osvojiš 30 €, tvoj multiplikator je 15.</i></p>
            <p>&nbsp;</p>
            <div className="divider"></div>
        </div>
    }

    function renderEGTDigital2025September() {
        return <div className="casino-superskok-section">
            <h2>EGT Digital SuperSkok vrijedi 100.000 € - upadaj!</h2>
            <p><strong>Super vrijedan nagradni fond za super igrače</strong></p>
            <p>U prvoj polovici rujna kreće <strong>SuperSkok</strong> koji nagrađuje <strong>čak 4000 igrača</strong>. Plasiraj se na rang-listu među najbolje i osvoji nagradu koja ti pripada. </p>
            <p>Nagradni fond iznosi <strong>100.000 €</strong>, a minimalni iznos za sudjelovanje je <strong>0,20 € po vrtnji</strong>. </p>
            <p>&nbsp;</p>

            <div>
                <p><b>KAKO IGRATI?</b></p>
                <p><strong>Od 1. do 14. rujna</strong> igraj bilo koju <strong>EGT Digital igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong> najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš! </p>
                <p><strong>Top 4000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                <p>&nbsp;</p>
                <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                <p>&nbsp;</p>
            </div>
            <div className="divider"></div>
        </div>
    }

    function renderFazi2025September() {
        return <div className="casino-superskok-section">
            <h2>Nagradu uhvati u SuperSkoku Fazi</h2>
            <p><strong>Skok po nagradu iz fonda od 12.000 €</strong></p>
            <p>Ne propusti novu priliku za osvajanje nagrada! Ostvari što bolji plasman na rang-listi <strong>najboljih 800 igrača</strong> i sudjeluj u podjeli fonda od <strong>12.000 €</strong>.</p>
            <p>&nbsp;</p>

            <div>
                <p><b>KAKO IGRATI?</b></p>
                <p><strong>Od 15. do 21. rujna</strong> igraj bilo koju <strong>Fazi igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>multiplikatore najvećih dobitnih vrtnji za svaki pojedini dan*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                <p>Najboljih 800 igrača osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade provjeri u tablici ispod 👇</p>
                <p>&nbsp;</p>
                <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                <p>&nbsp;</p>
            </div>
            <div className="divider"></div>
        </div>
    }

    function renderGamesGlobal2025September() {
        return <div className="casino-superskok-section">
            <h2>Games Global SuperSkok dijeli 10.000 €</h2>
            <p><strong>Nagrađujemo 800 igrača</strong></p>
            <p>Ne propusti novu priliku za osvajanje nagrada! Ostvari što bolji plasman na rang-listi <strong>najboljih 800 igrača</strong> i sudjeluj u podjeli nagradnog fonda od <strong>10.000 €</strong>.</p>
            <p>&nbsp;</p>

            <div>
                <p><b>KAKO IGRATI?</b></p>
                <p><strong>Od 22. do 28. rujna</strong> igraj bilo koju <strong>Games Global igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>multiplikatore najvećih dobitnih vrtnji* za svaki pojedini dan</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                <p><strong>Najboljih 800 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade provjeri u tablici ispod 👇</p>
                <p>&nbsp;</p>
                <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                <p>&nbsp;</p>
            </div>
            <div className="divider"></div>
        </div>
    }

    function renderEGTDigital2025October() {
        return <div className="casino-superskok-section">
            <h2>SuperSkok po nagradu u EGT Digital igrama</h2>
            <p><strong>Dijelimo nagradni fond od 50.000 €</strong></p>
            <p>Poskoči od sreće u osvajanju nagrade u novom SuperSkoku. Budi na rang-listi <strong>najboljih 2000 igrača</strong> i sudjeluj u podjeli fonda od <strong>50.000 €</strong>.</p>
            <p>&nbsp;</p>

            <div>
                <p><b>KAKO IGRATI?</b></p>
                <p><strong>Od 1. do 8. listopada</strong> igraj bilo koju <strong>EGT Digital igre</strong> s minimalnim ulogom od <strong>0,20 €</strong> i <strong>zbrajaj multiplikatore najvećih dobitnih vrtnji za svaki pojedini dan*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                <p><strong>Najboljih 2000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade provjeri u tablici ispod 👇</p>
                <p>&nbsp;</p>
                <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                <p>&nbsp;</p>
                <p>ℹ️ Osvojenu nagradu je potrebno prihvatiti u rubrici BONUSI na Casino računu</p>
                <p>&nbsp;</p>
            </div>
            <div className="divider"></div>
        </div>
    }

    function renderTech4Bet2025October() {
        return <div className="casino-superskok-section">
            <h2>Skoči više i osvoji više u Tech4Bet igrama</h2>
            <p><strong>Dijelimo 20.000 € u SuperSkoku</strong></p>
            <p>Do novih nagrada poskoči u Tech4Bet igrama!Budi na rang-listi <strong>najboljih 2000 igrača</strong> i sudjeluj u podjeli fonda od <strong>20.000 €</strong>.</p>
            <p>&nbsp;</p>

            <div>
                <p><b>KAKO IGRATI?</b></p>
                <p><strong>Od 22. do 29. listopada</strong> igraj bilo koju <strong>Tech4Bet</strong> igru s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>multiplikatore najvećih dobitnih vrtnji za svaki pojedini dan*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                <p><strong>Najboljih 2000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade provjeri u tablici ispod 👇</p>
                <p>&nbsp;</p>
                <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                <p>&nbsp;</p>
                <p>ℹ️ Osvojenu nagradu je potrebno prihvatiti u rubrici BONUSI na Casino računu</p>
                <p>&nbsp;</p>
            </div>
            <div className="divider"></div>
        </div>
    }

    function renderFazi2025November() {
        return <div className="casino-superskok-section">
            <h2>SuperSkokom do nove nagrade u Fazi igrama</h2>
            <p><strong>Dijelimo 10.000 € u odabranim Fazi igrama</strong></p>
            <p>Do novih nagrada poskoči u odabranim Fazi igrama! Budi na rang-listi <strong>najboljih 800 igrača</strong> i sudjeluj u podjeli fonda od <strong>10.000 €</strong>.</p>
            <p>&nbsp;</p>

            <div>
                <p><b>KAKO IGRATI?</b></p>
                <p><strong>Od 12. do 20. studenog</strong> igraj odabrane Fazi igre s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>multiplikatore najvećih dobitnih vrtnji za svaki pojedini dan*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                <p><strong>Najboljih 800 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade provjeri u tablici ispod 👇</p>
                <p>&nbsp;</p>
                <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                <p>&nbsp;</p>
                <p>ℹ️ Osvojenu nagradu je potrebno prihvatiti u rubrici BONUSI na Casino računu</p>
                <p>&nbsp;</p>
            </div>
            <div className="divider"></div>
        </div>
    }

    function renderExpanseDecember2025() {
        return <>
            <div className="casino-superskok-section">
                <h2>Blagdanski Expanse SuperSkok nagrađuje 1000 igrača</h2>
                <p><strong>Nagradni fond vrijedi 10.000 €</strong></p>
                <p>Uskoči po super nagrade za super igrače.</p>
                <p>Od 27. 12. 2025. do 1. 1. 2026. godine uključi se u SuperSkok zabavno osvajanje nagrada.</p>
                <p>Plasiraj se na rang-listu među najboljih 1000 igrača i osvoji nagradu iz fonda od 10.000 €.</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 27. 12. do 1. 1. 2026.</strong> igraj bilo koju <strong>Expanse igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 1000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                    <p>ℹ️ Osvojenu nagradu je potrebno prihvatiti u rubrici BONUSI na Casino računu</p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderTech4BetDecember2025() {
        return <>
            <div className="casino-superskok-section">
                <h2>Tech4Bet SuperSkok te nagrađuje - započni 2026. u punom skoku! </h2>
                <p><strong>20.000 € nagradnog fonda čeka 2000 najboljih igrača</strong></p>
                <p>Nova godina - novi početak…i nove šanse za nagrade. Tech4Bet SuperSkok utrka je neizvjesna do samog kraja, a svaka vrtnja je šansa za skok više u osvajanju vrijedne nagrade.</p>
                <p>Uključi se u utrku od 3. do 9. siječnja i u najdražim Tech4Bet igrama osvoji što bolje mjesto među top 2000 igrača koje nagrađujemo s fondom vrijednim 20.000 €.</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 3. 1. do 9. 1. 2026.</strong> igraj bilo koju <strong>Tech4Bet igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 2000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                    {/*<p>ℹ️ Osvojenu nagradu je potrebno prihvatiti u rubrici BONUSI na Casino računu</p>*/}
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }
    function renderTech4BetJuly2026() {
        return <>
            <div className="casino-superskok-section">
                <h2>Skoči u SuperSkok utrku za nagradu u Tech4Bet igrama</h2>
                <p>Uključi se u uzbudljivu utrku u kojoj svaki bod može napraviti razliku. 💪 Pokaži svoju formu i izbori se za mjesto među 2500 dobitnika.</p>
                <p>Dijelimo <strong>40.000 € vrijedan nagradni fond</strong>, a već jedna vrtnja može te lansirati na vrh. Budi među najboljima i osvoji nagradu!</p>
                <p>👉 <strong>Tech4Bet SuperSkok utrka</strong> je neizvjesna do samog kraja jer svaka vrtnja je šansa za skok na višu poziciju na bodovnoj rang-listi.</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 23. 7. do 29. 7. 2026.</strong> igraj bilo koju <strong>Tech4Bet igru</strong> s <strong>minimalnim ulogom od 0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 2500 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                    {/*<p>ℹ️ Osvojenu nagradu je potrebno prihvatiti u rubrici BONUSI na Casino računu</p>*/}
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderFaziFebruary2026() {
        return <>
            <div className="casino-superskok-section">
                <h2>Skoči do vrha u Fazi SuperSkoku</h2>
                <p><strong>10.000 € čeka 800 najboljih igrača</strong></p>
                <p>U ovom SuperSkoku čeka te nova šansa za nagrade. Fazi SuperSkok utrka je neizvjesna do samog kraja, a svaka vrtnja je šansa za skok više u osvajanju vrijedne nagrade.</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 9. 2. do 15. 2. 2026.</strong> igraj bilo koju <strong>Fazi igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 800 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderEGTDigitalFebruary2026() {
        return <>
            <div className="casino-superskok-section">
                <h2>Skok po nagradu u EGT Digital SuperSkoku</h2>
                <p><strong>20.000 € čeka 2000 top igrača</strong></p>
                <p>Pred tobom je nova šansa za nagrade. EGT Digital SuperSkok utrka je neizvjesna do samog kraja, a svaka vrtnja je šansa za skok više u osvajanju vrijedne nagrade.</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 16. 2. do 22. 2. 2026.</strong> igraj bilo koju <strong>EGT Digital igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 2000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderEGTDigitalMarch2026() {
        return <>
            <div className="casino-superskok-section">
                <h2>Skoči po najbolju nagradu u EGT Digital SuperSkoku</h2>
                <p><strong>20.000 € čeka 2000 top igrača</strong></p>
                <p>Utrkuj se i zauzmi mjesto među pobjednicima. 🏆 EGT Digital SuperSkok utrka je neizvjesna do samog kraja, a svaka vrtnja je šansa za skok više u osvajanju vrijedne nagrade.</p>
                <p>Zbrajaj svoje najveće dnevne multiplikatore i poskoči do najboljeg mjesta na rang ljestvici. </p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 23. 3. do 29. 3. 2026.</strong> igraj bilo koju <strong>EGT Digital igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 2000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderFaziApril2026() {
        return <>
            <div className="casino-superskok-section">
                <h2>Hop u Fazi SuperSkok</h2>
                <p><strong>10.000 € čeka 800 top igrača</strong></p>
                <p>📣 Utrkuj se za što bolju nagradu! 🏆 U Fazi SuperSkoku svaka je vrtnja šansa za skok više na ljestvici top igrača koji osvajaju nagradu.</p>
                <p>Igraj više, skoči više! Zbrajaj svoje najveće dnevne multiplikatore i poskoči do najboljeg mjesta na rang ljestvici.</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 6. 4. do 12. 4. 2026.</strong> igraj bilo koju <strong>Fazi igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 800 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderEGTDigitalMay2026() {
        return <>
            <div className="casino-superskok-section">
                <h2>Svaki bod je skok na višu poziciju u EGT Digital SuperSkoku</h2>
                <p><strong>Nagrađujemo 2000 najboljih igrača</strong></p>
                <p>SuperSkok je krenuo, a mi smo pripremili nagrade za TOP 2000 igrača. Već jedna vrtnja može te lansirati na vrh. Budi među najboljima i osvoji svoju nagradu.</p>
                <p>👉 EGT Digital SuperSkok utrka je neizvjesna do samog kraja jer svaka vrtnja je šansa za skok na višu poziciju na bodovnoj rang-listi.</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 1. 5. do 7. 5. 2026.</strong> igraj bilo koju <strong>EGT Digital igru</strong> s minimalnim ulogom od <strong>0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 2000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderAmusnetJuly2026() {
        return <>
            <div className="casino-superskok-section">
                <h2>Skoči među 3000 dobitnika Amusnet SuperSkoka</h2>
                <p>Skoči do svoje nagrade! Pridruži se SuperSkok utrci i skoči među 3000 dobitnika. Dijelimo 50.000 € vrijedan nagradni fond, a već jedna vrtnja može te lansirati na vrh. Budi među najboljima i osvoji nagradu!</p>
                <p>👉 Amusnet SuperSkok utrka je neizvjesna do samog kraja jer svaka vrtnja je šansa za skok na višu poziciju na bodovnoj rang-listi. </p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 8. 7. do 15. 7. 2026.</strong> igraj bilo koju <strong>Amusnet igru s minimalnim ulogom od 0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš!</p>
                    <p><strong>Top 3000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde. Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }

    function renderSuperIgreAugust2026() {
        return <>
            <div className="casino-superskok-section">
                <h2><strong>SuperSkok u SuperIgrama za top nagrade</strong></h2>
                <p>Spin po spin i bod po bod za skok do vrha! Uključi se u uzbudljivu utrku u kojoj svaki bod može napraviti razliku. </p>
                <p>&nbsp;</p>
                <p>Dijelimo <strong>20.000 € vrijedan nagradni fond</strong>, a nagrađujemo najboljih <strong>1000 igrača</strong>. Budi među najboljima i osvoji nagradu! </p>
                <p>👉 <strong>SuperSkok utrka u SuperIgrama</strong> je neizvjesna do samog kraja jer svaka vrtnja je šansa za skok na višu poziciju na bodovnoj rang-listi.</p>
                <p><strong>Skoči visoko na ljestvici i osvoji nagradu!</strong></p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 17. 8. do 23. 8. 2026.</strong> igraj <strong>odabrane SuperIgre</strong> s <strong>minimalnim ulogom od 0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>. Što bolji plasman ostvariš, to bolju nagradu osvajaš! </p>
                    <p><strong>Top 1000 igrača</strong> osvaja nagradu, a konačni poredak ostaje neizvjestan do posljednje sekunde.</p>
                    <p>Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }
    function renderEgtDigitalSeptember2026() {
        return <>
            <div className="casino-superskok-section">
                <h2><strong>Nagrađujemo top 2000 najboljih igrača</strong></h2>
                <p>EGT Digital SuperSkok utrka je neizvjesna do samog kraja, a već jedna vrtnja može učiniti razliku. 🆙🆙</p>
                <p>&nbsp;</p>
                <p>🏆 U ovom SuperSkoku nagrađujemo <strong>najboljih 2000 igrača</strong> pa igraj <strong>EGT Digital igre</strong> i budi među najboljima koji osvajaju <strong>nagrade iz fonda vrijednog 30.000 €</strong> ! 🎉</p>
                <p>&nbsp;</p>

                <div>
                    <p><b>KAKO IGRATI?</b></p>
                    <p><strong>Od 7. 9. do 13. 9. 2026.</strong> igraj bilo koju <strong>EGT Digital igru</strong> s <strong>minimalnim ulogom od 0,20 €</strong> i zbrajaj <strong>najveće dnevne multiplikatore*</strong>.</p>
                    <p>Što bolji plasman ostvariš, to bolju nagradu osvajaš! 🎁</p>
                    <p><strong>Top 2000 igrača osvaja nagradu</strong>, a konačni poredak ostaje neizvjestan do posljednje sekunde.</p>
                    <p>Nagrade za najbolje možeš provjeriti u tablici ispod 👇</p>
                    <p>&nbsp;</p>
                    <p><i>*Multiplikator = dobitak iz vrtnje/ulog u vrtnju. Dakle, ako odigraš spin za 2 €, a dobitak je 30 € - multiplikator iznosi 15.</i></p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </>
    }
    function renderInfo() {
        switch (props.kampanja) {
            case 'egt-digital-2025-07':
                return renderEGTDigital2025July();
            case 'fazi-2025-07':
                return renderFazi2025July();
            case '7777-2025-08':
                return render7777Gaming2025August();
            case 'fazi-2025-08':
                return renderFazi2025August();
            case 'egt-digital-2025-09':
                return renderEGTDigital2025September();
            case 'fazi-2025-09':
                return renderFazi2025September();
            case 'gamesglobal-2025-09':
                return renderGamesGlobal2025September();
            case 'egt-digital-2025-10':
                return renderEGTDigital2025October();
            case 'tech4bet-2025-10':
                return renderTech4Bet2025October();
            case 'fazi-2025-11':
                return renderFazi2025November();
            case 'expanse-2025-12':
                return renderExpanseDecember2025();
            case 'tech4bet-2026-01':
                return renderTech4BetDecember2025();
            case 'tech4bet-2026-07':
                return renderTech4BetJuly2026();
            case 'fazi-2026-02':
                return renderFaziFebruary2026();
            case 'egt-digital-2026-02':
                return renderEGTDigitalFebruary2026();
            case 'egt-digital-2026-03':
                return renderEGTDigitalMarch2026();
            case 'fazi-2026-04':
                return renderFaziApril2026();
            case 'egt-digital-2026-05':
                return renderEGTDigitalMay2026();
            case 'amusnet-2026-07':
                return renderAmusnetJuly2026();
            case 'superigre-2026-08':
                return renderSuperIgreAugust2026();
            case 'egt-digital-2026-09':
                return renderEgtDigitalSeptember2026();
            default:
                return renderFazi2022October();
        }
    }

    return (
        <div className="content margin">
            {renderInfo()}
        </div>
    )
}